import React from 'react'
import { Button, Col, DatePicker, Form, InputNumber, Row, Select, Space, Switch } from 'antd'

import { TithiOption, mergeTithiOptions } from '../utils/helper'

interface EventCalendarFormProps {
    form: any
    onFinish: (values: any) => void
    onCancel: () => void
    isEditing: boolean
    tithiOptions: TithiOption[]
    loadingTithis?: boolean
    editingRecord?: any
    tithiById?: Map<string, any>
    submitting?: boolean
}

const EventCalendarForm: React.FC<EventCalendarFormProps> = ({
    form,
    onFinish,
    onCancel,
    isEditing,
    tithiOptions,
    loadingTithis,
    editingRecord,
    tithiById,
    submitting = false,
}) => {
    const selectedEntityId = Form.useWatch('id', form)

    const mergedTithiOptions = React.useMemo(
        () => mergeTithiOptions(tithiOptions, editingRecord, selectedEntityId, tithiById),
        [tithiOptions, editingRecord, selectedEntityId, tithiById],
    )

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            {/* <Row gutter={16}> */}
            {/* <Col span={12}> */}
            <Form.Item
                label="Date"
                name="event_date"
                rules={[{ required: true, message: 'Please select date' }]}
            >
                <DatePicker
                    style={{ width: '100%' }}
                    format="YYYY-MM-DD"
                    showTime={false}
                    onChange={(date) => {
                        if (date) {
                            form.setFieldValue('event_date', date.startOf('day'))
                        }
                    }}
                />
            </Form.Item>

            <Form.Item
                label="Tithi ID"
                name="id"
                rules={[{ required: true, message: 'Please select entity id (Tithi)' }]}
            >
                <Select
                    placeholder="Select Tithi"
                    loading={!!loadingTithis}
                    options={mergedTithiOptions}
                    showSearch
                    optionFilterProp="label"
                    filterOption
                />
            </Form.Item>

            <Row gutter={16}>
                <Col span={12}>
                    <Form.Item
                        label="Position"
                        name="position"
                        rules={[{ required: true, message: 'Please enter position' }]}
                    >
                        <InputNumber min={0} style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Active" name="active" valuePropName="checked">
                        <Switch />
                    </Form.Item>
                </Col>
            </Row>

            <Form.Item>
                <Space>
                    <Button type="primary" htmlType="submit" loading={submitting} disabled={submitting}>
                        {isEditing ? 'Update' : 'Create'}
                    </Button>
                    <Button onClick={onCancel} disabled={submitting}>Cancel</Button>
                </Space>
            </Form.Item>
        </Form>
    )
}

export default EventCalendarForm
